import { Component } from '@angular/core';
import { NewDealStandardQuoteWrapperComponent } from '../new-deal-standard-quote-wrapper.component';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';


@Component({
  selector: 'app-new-deal-standard-quote-mobile',
  templateUrl: './new-deal-standard-quote-mobile.component.html',
  styleUrls: ['./new-deal-standard-quote-mobile.component.scss'],
})
export class NewDealStandardQuoteMobileComponent extends NewDealStandardQuoteWrapperComponent {
  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menuService, notification);
  }
}
